/**
 * Zod schemas for GET /v1/admin/compliance-documents, mirroring
 * `backend/src/compliance_documents/schemas/admin.py`.
 *
 * The list is a bare array of catalog slots (not a cursor page). Preview and
 * download are the stored file bytes, not a JSON handshake.
 *
 * `catalog_type` and `cardinality` stay `z.string()`: the admin catalog can
 * grow additively, and a closed enum would trip parse at the client.
 */
import { z } from 'zod';

export const adminComplianceDocumentFileSchema = z.object({
  id: z.string(),
  catalog_type: z.string(),
  file_name: z.string(),
  mime_type: z.string(),
  file_size_bytes: z.number(),
  created_at: z.string(),
  updated_at: z.string().nullable(),
});

export type AdminComplianceDocumentFile = z.infer<typeof adminComplianceDocumentFileSchema>;

export const adminComplianceDocumentGroupSchema = z.object({
  catalog_type: z.string(),
  label: z.string(),
  cardinality: z.string(),
  last_updated: z.string().nullable(),
  documents: z.array(adminComplianceDocumentFileSchema),
});

export type AdminComplianceDocumentGroup = z.infer<typeof adminComplianceDocumentGroupSchema>;

export const adminComplianceDocumentCatalogSchema = z.array(adminComplianceDocumentGroupSchema);
